import { Controller } from "@hotwired/stimulus"

// Each dismissible info box has its own localStorage key so one browser can hide
// that specific alert without affecting other alerts or other browsers.
export default class extends Controller {
  static values = {
    storageKey: String
  }

  connect() {
    // Backup for the inline check, in case that script did not run before the box was shown.
    if (this.alreadyDismissed()) {
      this.element.remove()
    }
  }

  dismiss(event) {
    event.preventDefault()

    try {
      localStorage.setItem(this.storageKeyValue, "dismissed")
    } catch (error) {
      // Private browsing can block localStorage. Still hide the box for this page view.
    }

    this.element.remove()
  }

  alreadyDismissed() {
    try {
      return localStorage.getItem(this.storageKeyValue) === "dismissed"
    } catch (error) {
      return false
    }
  }
}
